module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/affordability.json
// module id = 445
// module chunks = 223273660771876